export default "__VITE_ASSET__a565d288__"